export const CMR_TYPES = Object.freeze({
  CMR_AVC: 1,
  CMR: 2,
  AVC: 3,
  CMR_HGB: 4,
  HGB: 5,
  DeCA: 6
})

export const CMR_STATUSES = Object.freeze({
  Created: 1,
  ReadySigning: 2,
  SignatureShipper: 3,
  SignatureDriver: 4,
  SignatureReceiver: 5,
  Mailing: 6,
  Closed: 7,
  Removed: 8,
  Unfinished: 9
})
